/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import SetupGuide from 'cio/models/setup-guide';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import { isEmpty } from '@ember/utils';
import AnalyticsService from 'cio/services/analytics';
import ExperimentsService from 'cio/services/experiments';
import { action } from '@ember/object';
import EnvironmentService from 'cio/services/environment';

interface SetupGuideIntroductionArgs {
  setupGuide: SetupGuide;
  startLabel: string;
  start: () => unknown;
}

export default class SetupGuideIntroduction extends Component<SetupGuideIntroductionArgs> {
  @service auth!: AuthService;
  @service account!: AccountService;
  @service analytics!: AnalyticsService;
  @service experiments!: ExperimentsService;
  @service environment!: EnvironmentService;

  get variation() {
    return this.experiments.getExperimentVariation('welcomeMessageExperiment');
  }

  get environmentName() {
    return !isEmpty(this.environment?.current?.name) ? this.environment?.current?.name : 'your workspace';
  }

  get highlightAutomatedMessages() {
    let { useCase } = this.args.setupGuide;
    return (
      useCase === 'onboard_or_retain' ||
      useCase === 'leads' ||
      useCase === 'internal_automations' ||
      useCase === 'other' ||
      isEmpty(useCase)
    );
  }

  get highlightOneTimeSends() {
    return this.args.setupGuide.useCase === 'newsletters';
  }

  get highlightTransactionalMessages() {
    return this.args.setupGuide.useCase === 'transactional';
  }

  @action
  onVideoStart() {
    this.analytics.track('onboarding', 'setup_guide_product_tour_video_started', {
      account_id: this.account?.current?.id,
    });
  }

  constructor(owner: unknown, args: SetupGuideIntroductionArgs) {
    super(owner, args);
    if (this.variation === 'welcome_message_variation_a') {
      this.analytics.track('onboarding', 'setup_guide_product_tour_video_loaded', {
        account_id: this.account?.current?.id,
      });
    } else {
      this.analytics.track('onboarding', 'setup_guide_product_tour_video_not_included', {
        account_id: this.account?.current?.id,
      });
    }
  }
}
